import { downloadCSV, getCSVString, toISO8601 } from '@fortem-monorepo/js-utilities';
const getChartTitleFromOptions = (options) => {
    return typeof options.title?.text === 'object'
        ? options.title.text.join(', ')
        : (options.title?.text ?? `chart-data-${toISO8601(new Date())}`);
};
export const exportDataPlugin = {
    augmentOptions: (options) => {
        // Typescript requires type narrowing here to check if series may contain data or not
        // There are a lot of types to narrow however, we just need a generic check
        const hasSeriesWithData = 
        // @ts-ignore
        (options.series ?? []).filter((series) => series?.data).length > 0;
        const exportDataMenuItem = {
            label: 'Export Data',
            action: () => {
                const chartTitle = getChartTitleFromOptions(options);
                if (options.data) {
                    downloadCSV(getCSVString(options.data), chartTitle);
                }
                else if (hasSeriesWithData) {
                    // Same issue repeated here
                    const data = options
                        // @ts-ignore
                        .series.map((series) => series.data ?? [])
                        .flat();
                    downloadCSV(getCSVString(data), chartTitle);
                }
            },
        };
        return {
            ...options,
            contextMenu: {
                ...options.contextMenu,
                items: [...(options.contextMenu?.items ?? []), 'separator', exportDataMenuItem],
            },
        };
    },
};
